import { v4 as uuid } from 'uuid';
import { TreeNavigatorLogic } from '../../../tree/navigation/TreeNavigatorLogic';
import { IRootWidgetIdentifier } from '../../../tree/references';
import { ICodeWidget, hasCode } from '../ICodeWidget';
import { Widget } from '../Widget';
import { extractAllCodesMap } from '../validation/hooks/useConfigValidationContext';

export class WidgetCloner {
  static getUniqueCode(
    widget: Widget & ICodeWidget,
    allCodes: Map<string, string[]>,
  ): string {
    let i = 0;
    do {
      i++;
      const newCode = `${widget.code}_${i}`;

      if (!allCodes.has(newCode)) {
        const values = allCodes.get(newCode);
        if (!values || values.length === 0) return newCode;
      }
    } while (i < 100);

    return widget.code + '_' + uuid().slice(0, 8);
  }

  /**
   * Crea la copia di un widget, modificandone gli id e i codici così che possa essere inserito
   * altrove. Ritorna la stringa che rappresenta il widget.
   */
  static copyWidget(input: Widget): string {
    const clonedWidget = structuredClone(input);
    return this.stringifyWidget(clonedWidget);
  }

  static getClonedWidget(
    input: string,
    allRoots: IRootWidgetIdentifier[] | undefined,
  ): Widget {
    const result = WidgetCloner.parseWidget(input);

    const { allCodes } = extractAllCodesMap(allRoots);

    // Rendo univoco il widget modificando ID e codice
    TreeNavigatorLogic.forEachNode(result, node => {
      node.id = uuid();
      if (hasCode(node)) node.code = WidgetCloner.getUniqueCode(node, allCodes);
    });

    return result;
  }
  /**
   * Trasforma un widget in una stringa JSON.
   */
  static stringifyWidget(input: Widget): string {
    return JSON.stringify(input);
  }

  static parseWidget(input: string): Widget {
    return JSON.parse(input);
  }
}
